import {
  Bell,
  UserPlus,
  Clock,
  CreditCard,
  RefreshCw,
} from "lucide-react";

export const getNotificationIcon = (type: string) => {
  switch (type) {
    case "USER_REGISTERED":
      return {
        icon: <UserPlus size={16} />,
        className: "nav-notification__type--success",
      };

    case "SUBSCRIPTION_EXPIRY":
      return {
        icon: <Clock size={16} />,
        className: "nav-notification__type--warning",
      };

    case "SUBSCRIPTION_PURCHASED":
      return {
        icon: <CreditCard size={16} />,
        className: "nav-notification__type--info",
      };

    case "SUBSCRIPTION_RENEWED":
      return {
        icon: <RefreshCw size={16} />,
        className: "nav-notification__type--info",
      };

    default:
      return {
        icon: <Bell size={16} />,
        className: "nav-notification__type--primary",
      };
  }
};
